(function(){
  function text(el){ return (el && el.textContent ? el.textContent : '').toLowerCase(); }
  function clean(v){ return String(v || '').toLowerCase().replace(/eu/g,'').replace(/rozmiar/g,'').replace(/size/g,'').replace(/,/g,'.').replace(/\s+/g,' ').trim(); }
  function matchSize(value,size){
    var v = clean(value); var s = clean(size);
    if(!v || !s) return false;
    if(v === s) return true;
    return new RegExp('(^|[^0-9])' + s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + '([^0-9]|$)').test(v);
  }
  function addCss(){
    if(document.getElementById('plawny-size-chart-click-css')) return;
    var css = document.createElement('style');
    css.id = 'plawny-size-chart-click-css';
    css.textContent = '.ppp-size-table div{cursor:pointer;transition:.18s ease}.ppp-size-table div:hover{transform:translateY(-2px);border-color:#d49a35!important;box-shadow:0 10px 24px rgba(6,19,33,.08)}.ppp-size-table div.is-selected{background:#061321!important;color:#fff!important;border-color:#e3bd79!important}.ppp-size-table div.is-selected span{color:rgba(255,255,255,.72)!important}.ppp-size-table div.is-disabled{opacity:.36;filter:grayscale(1);cursor:not-allowed;pointer-events:none}.ppp-size-status{min-height:20px;margin-top:10px;color:#e3bd79;font-size:13px;font-weight:900}.ppp-size-note{margin:12px 0 0;padding:12px 14px;border-radius:16px;background:rgba(212,154,53,.12);color:#061321;font-size:14px;font-weight:800;line-height:1.45}.ppp-size-table div.not-found{animation:pppSizeShake .28s ease;border-color:#c84b4b!important}@keyframes pppSizeShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-3px)}75%{transform:translateX(3px)}}';
    document.head.appendChild(css);
  }
  function detectGender(root){
    var h1 = text(root.querySelector('h1'));
    var path = (location.pathname || '').toLowerCase();
    if(path.indexOf('polbuty-meskie') > -1 || path.indexOf('półbuty-męskie') > -1 || path.indexOf('polbut-meski') > -1 || path.indexOf('półbut-męski') > -1) return 'men';
    if(h1.indexOf('półbut') > -1 && (h1.indexOf('męsk') > -1 || h1.indexOf('mesk') > -1)) return 'men';
    return 'women';
  }
  function setButtonLoading(form, loading){
    var btn = form ? form.querySelector('button[type="submit"]') : null;
    if(!btn) return;
    if(loading){ btn.setAttribute('data-old-text', btn.textContent); btn.textContent = 'Dodawanie...'; btn.disabled = true; }
    else { btn.textContent = btn.getAttribute('data-old-text') || 'Dodaj do koszyka'; btn.disabled = false; }
  }
  function stopEvent(e){ if(!e) return; e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  function addToCart(form, variantId, status){
    if(!form || !variantId) return;
    if(form.getAttribute('data-plawny-adding') === '1') return;
    form.setAttribute('data-plawny-adding','1');
    setButtonLoading(form, true);
    if(status) status.textContent = 'Dodaję do koszyka...';
    var payload = new URLSearchParams();
    payload.set('id', variantId);
    payload.set('quantity', '1');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: payload.toString()
    }).then(function(res){
      if(!res.ok) return res.json().then(function(err){ throw err; });
      return res.json();
    }).then(function(){
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    }).then(function(res){ return res.json(); })
    .then(function(cart){
      if(cart && cart.item_count > 0){
        if(status) status.textContent = 'Dodano do koszyka.';
        window.location.href = '/cart';
      } else {
        throw { description: 'Koszyk dalej jest pusty. Spróbuj kliknąć jeszcze raz.' };
      }
    }).catch(function(err){
      if(status) status.textContent = (err && err.description) ? err.description : 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.';
      form.removeAttribute('data-plawny-adding');
      setButtonLoading(form, false);
    });
  }
  function init(root){
    if(!root || root.getAttribute('data-plawny-size-ready') === '3') return;
    root.setAttribute('data-plawny-size-ready','3');
    addCss();
    var gender = detectGender(root);
    root.setAttribute('data-product-gender', gender);
    var modal = root.querySelector('[data-size-modal]');
    var box = root.querySelector('.ppp-size-box');
    var form = root.querySelector('form.ppp-form');
    var status = root.querySelector('[data-size-status]');
    if(!status && form){ status = document.createElement('div'); status.className = 'ppp-size-status'; status.setAttribute('data-size-status',''); form.insertAdjacentElement('afterend', status); }
    if(box){
      var oldNote = box.querySelector('.ppp-size-note'); if(oldNote) oldNote.remove();
      var note = document.createElement('p'); note.className = 'ppp-size-note';
      note.textContent = gender === 'men' ? 'Ten produkt jest z działu półbuty męskie. Kliknięcie rozmiaru od razu doda produkt do koszyka.' : 'Ten produkt jest damski. Kliknięcie rozmiaru od razu doda produkt do koszyka.';
      var intro = box.querySelector('.ppp-size-intro'); if(intro) intro.insertAdjacentElement('afterend', note);
    }
    var panels = root.querySelectorAll('[data-size-panel]');
    panels.forEach(function(panel){
      var panelGender = panel.getAttribute('data-size-panel');
      panel.querySelectorAll('div').forEach(function(tile){
        tile.setAttribute('role','button'); tile.setAttribute('tabindex','0');
        tile.setAttribute('data-size-gender', panelGender);
        var b = tile.querySelector('b'); tile.setAttribute('data-size-value', b ? b.textContent.trim() : '');
        tile.classList.toggle('is-disabled', panelGender !== gender);
        if(panelGender !== gender){ tile.setAttribute('aria-disabled','true'); } else { tile.removeAttribute('aria-disabled'); }
      });
    });
    var tabs = root.querySelectorAll('[data-size-tab]');
    tabs.forEach(function(tab){
      var tabGender = tab.getAttribute('data-size-tab');
      tab.classList.toggle('active', tabGender === gender);
      tab.addEventListener('click', function(){
        tabs.forEach(function(x){x.classList.remove('active')});
        panels.forEach(function(x){x.classList.remove('active')});
        tab.classList.add('active');
        var panel = root.querySelector('[data-size-panel="'+tabGender+'"]'); if(panel) panel.classList.add('active');
      });
    });
    panels.forEach(function(panel){ panel.classList.toggle('active', panel.getAttribute('data-size-panel') === gender); });
    function findInput(size){
      var labels = Array.prototype.slice.call(root.querySelectorAll('.ppp-size-pill'));
      for(var i=0;i<labels.length;i++){
        var lab = labels[i]; var input = lab.querySelector('input[name="id"]');
        if(!input || input.disabled) continue;
        var val = lab.textContent;
        if(matchSize(val, size)) return input;
      }
      return null;
    }
    function currentInput(){ return form ? (form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]')) : null; }
    function choose(tile){
      if(!tile || tile.classList.contains('is-disabled')) return;
      var size = tile.getAttribute('data-size-value');
      var input = findInput(size);
      if(!input){ tile.classList.add('not-found'); setTimeout(function(){tile.classList.remove('not-found')},350); if(status) status.textContent = 'Ten rozmiar nie jest dostępny dla tego produktu.'; return; }
      input.checked = true;
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
      var select = root.querySelector('.ppp-hidden-select'); if(select){ select.value = input.value; select.dispatchEvent(new Event('change',{bubbles:true})); }
      root.querySelectorAll('.ppp-size-table div').forEach(function(x){x.classList.remove('is-selected')});
      tile.classList.add('is-selected');
      if(modal){ modal.hidden = true; document.body.style.overflow = ''; }
      addToCart(form, input.value, status);
    }
    root.querySelectorAll('.ppp-size-table div').forEach(function(tile){
      tile.addEventListener('click', function(e){ stopEvent(e); choose(tile); }, true);
      tile.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ stopEvent(e); choose(tile); } }, true);
    });
    if(form && !form.getAttribute('data-plawny-form-fixed')){
      form.setAttribute('data-plawny-form-fixed','1');
      form.addEventListener('submit', function(e){
        var checked = currentInput();
        if(checked && checked.value){ stopEvent(e); addToCart(form, checked.value, status); return false; }
      }, true);
      var submitBtn = form.querySelector('button[type="submit"]');
      if(submitBtn){
        submitBtn.addEventListener('click', function(e){
          var checked = currentInput();
          if(checked && checked.value){ stopEvent(e); addToCart(form, checked.value, status); return false; }
        }, true);
      }
    }
  }
  function boot(){ document.querySelectorAll('.ppp').forEach(function(root){ root.removeAttribute('data-plawny-size-ready'); init(root); }); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
